import {useRouter} from 'next/router';

export const useIsVerboseLocale = (): boolean => {
	const {locale} = useRouter();

	if (locale === 'de' || locale === 'ru') return true;
	return false;
};
